var map = {
	"./bookings.png": "f6bb",
	"./cal.png": "a665",
	"./cal.webp": "4592",
	"./compv2.webp": "6cab",
	"./contact.webp": "1010",
	"./docs.webp": "3e25",
	"./driving-lessons.webp": "bf40",
	"./dwdoc.webp": "f125",
	"./feedback.webp": "af7e",
	"./feedback2.webp": "5f4a",
	"./info.webp": "ee76",
	"./instructor.webp": "43d8",
	"./instructor3.webp": "01e8",
	"./learner.webp": "9e32",
	"./lesson.webp": "bd7e",
	"./money.webp": "b716",
	"./notification.webp": "fa52",
	"./ourinfo.webp": "b7fa",
	"./qinfo.webp": "693e",
	"./qinfo2.webp": "2fcd",
	"./rate.webp": "9dc9",
	"./reflective.webp": "d744",
	"./report.webp": "bf52",
	"./review.webp": "c0b2",
	"./staff.webp": "a15bb",
	"./staffico.webp": "675c",
	"./syllabus.webp": "a947",
	"./tasks.webp": "492a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c320";